import fs from 'node:fs'
import path from 'node:path'
import os from 'node:os'
import { transformContent, getGsdMunchHome, getPkgRoot } from './assets.js'

/**
 * Target directory for gsd-munch command stubs.
 * Coexists alongside upstream GSD's ~/.claude/commands/gsd/ without conflict.
 */
export const COMMANDS_GM_DIR = path.join(os.homedir(), '.claude', 'commands', 'gm')

/**
 * Reads all .md command stub templates from the package commands/ directory,
 * applies transformContent to each (updating paths and /gsd: -> /gm: namespace),
 * and writes them to ~/.claude/commands/gm/.
 *
 * Creates the target directory if it doesn't exist.
 * Safe to re-run — overwrites existing stubs (idempotent by design).
 *
 * @param gsdMunchHome Deployed assets home directory (defaults to ~/.claude/gsd-munch)
 */
export async function registerCommands(gsdMunchHome = getGsdMunchHome()): Promise<void> {
  const stubSrcDir = path.join(getPkgRoot(), 'commands')

  if (!fs.existsSync(stubSrcDir)) {
    return
  }

  fs.mkdirSync(COMMANDS_GM_DIR, { recursive: true })

  for (const file of fs.readdirSync(stubSrcDir)) {
    if (!file.endsWith('.md')) continue
    const content = fs.readFileSync(path.join(stubSrcDir, file), 'utf-8')
    const adapted = transformContent(content, gsdMunchHome)
    fs.writeFileSync(path.join(COMMANDS_GM_DIR, file), adapted, 'utf-8')
  }
}
